import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import demoHome from '../views/demoHome.vue';
import BusinessCardFields from '../views/BusinessCardFields.vue';
import ConfirmationPage from '../views/ConfirmationPage.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/demoHome',
    name: 'demoHome',
    redirect: '/BusinessCardFields',
    component: demoHome,
    children: [
      {
        path: '/BusinessCardFields',
        name: 'BusinessCardFields',
        component: BusinessCardFields
      },
      {
        path: '/ConfirmationPage',
        name: 'ConfirmationPage',
        component: ConfirmationPage
      }
    ],
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
